/**
 * The workspace object types (ADR-001 D5) on their own, so modules the
 * registry itself uses (src/lib/mentions.ts) can validate a type without an
 * import cycle. Dependency-free; src/lib/workspace-objects.ts re-exports them.
 */
export const WORKSPACE_OBJECT_TYPES = [
  "contact",
  "company",
  "deal",
  "project",
  "document",
  "note",
  "task",
] as const;

export type WorkspaceObjectType = (typeof WORKSPACE_OBJECT_TYPES)[number];

export function isWorkspaceObjectType(value: unknown): value is WorkspaceObjectType {
  return typeof value === "string" && (WORKSPACE_OBJECT_TYPES as readonly string[]).includes(value);
}
